import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '=',
        roles: '=',
        levels: '=',
        course: '=',
        preselectedNeedType: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Add target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.courseTargets">
                    <span ng-bind-html="vm.form.errors.courseTargets"></span>
                </form-row>
                <div class="form">
                    <form-row error="vm.form.errors.departmentId">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <form-row-error></form-row-error>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.toggleDepartment"
                                options="vm.departmentSelect.options"
                                selected-model="vm.departmentSelect.models"
                                extra-settings="vm.departmentSelect.settings"
                                events="vm.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.toggleDepartment"
                                options="vm.departmentSelect.options"
                                selected-model="vm.departmentSelect.models"
                                extra-settings="vm.departmentSelect.settings"
                                events="vm.departmentSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.roleId">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <form-row-error></form-row-error>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.toggleRole"
                                options="vm.roleSelect.options"
                                selected-model="vm.roleSelect.models"
                                extra-settings="vm.roleSelect.settings"
                                events="vm.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.toggleRole"
                                options="vm.roleSelect.options"
                                selected-model="vm.roleSelect.models"
                                extra-settings="vm.roleSelect.settings"
                                events="vm.roleSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.levelId">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <form-row-error></form-row-error>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                ng-if="vm.toggleLevel"
                                options="vm.levelSelect.options"
                                selected-model="vm.levelSelect.models"
                                extra-settings="vm.levelSelect.settings"
                                events="vm.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                            <div ng-dropdown-multiselect=""
                                ng-if="!vm.toggleLevel"
                                options="vm.levelSelect.options"
                                selected-model="vm.levelSelect.models"
                                extra-settings="vm.levelSelect.settings"
                                events="vm.levelSelect.events"
                                translation-texts="vm.filterTranslations"
                            ></div>
                        </div>
                    </form-row>
                    <form-row ng-if="vm.TokenService.isOptionalCoursesModuleEnabled()" error="vm.form.errors.type">
                        <label class="label">{{ 'courses.Training need' | translate }}</label>
                        <form-row-error></form-row-error>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label ng-repeat="(value, label) in vm.COURSE_TARGET_NEED_TYPE_ENUM.LABELS">
                                        <input ng-model="vm.form.model.type" value="{{ value }}" type="radio" name="r01"> {{ label }}
                                    </label>
                                </li>
                            </ul>
                        </div>
                    </form-row>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save($event)">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $scope, lodash, FormFactory, CourseService, TokenService, FilterService, CLASSIFIER_ENUM, COURSE_TARGET_NEED_TYPE_ENUM) {
        this.$translate = $translate;
        this.$scope = $scope;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.TokenService = TokenService;
        this.CourseService = CourseService;
        this.FilterService = FilterService;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
    }

    $onInit () {
        this.filterTranslations = this.FilterService.getTranslations();

        this.createForm();
        this.initMultiSelects();
    }

    /**
     * Maps possible selectbox options to suitable format
     * @param classifier
     * @param defaultModel
     * @param type
     * @returns {*}
     */
    mapModels (classifier, defaultModel, type) {
        classifier = classifier.map((val) => ({
            id: val.id,
            type,
            label: val.value
        }));
        classifier.unshift(defaultModel);
        return classifier;
    }

    /**
     * Resets form drls to db state
     */
    resetFormDrls () {
        this.form.model.courseTargets = angular.copy(this.course.courseTargetsWithValue);
    }

    createForm () {
        this.CourseService.nestCompositeModels(this.course);
        this.form = this.FormFactory.create(this.course, model => model.$update({ id: model.id }));
        if (this.form.model.expirationMonths === null) {
            this.form.model.expirationMonths = 0;
        }
        this.form.model.fields = this.course.courseFields.map((field) => (field.fieldId));
        this.form.model.courseSiteIds = this.course.sites.map(site => (site.id));
        this.form.model.courseTrainings = this.course.courseTrainings;
        this.resetFormDrls();
        if (this.preselectedNeedType) {
            this.form.model.type = this.preselectedNeedType;
        }
    }

    /**
     * Initializes various variable needed to manipulate selectboxes
     */
    initMultiSelects () {
        this.toggleDepartment = this.toggleRole = this.toggleLevel = true;
        this.allDepartmentModel = {
            id: null,
            type: this.CLASSIFIER_ENUM.KEYS.DEPARTMENT,
            label: this.$translate.instant('course.All departments')
        };
        this.allRoleModel = {
            id: null,
            type: this.CLASSIFIER_ENUM.KEYS.ROLE,
            label: this.$translate.instant('course.All roles')
        };
        this.allLevelModel = {
            id: null,
            type: this.CLASSIFIER_ENUM.KEYS.LEVEL,
            label: this.$translate.instant('course.All levels')
        };

        const departments = this.mapModels(this.departments, this.allDepartmentModel, this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        const roles = this.mapModels(this.roles, this.allRoleModel, this.CLASSIFIER_ENUM.KEYS.ROLE);
        const levels = this.mapModels(this.levels, this.allLevelModel, this.CLASSIFIER_ENUM.KEYS.LEVEL);

        this.departmentSelect = this.getFilter(departments);
        this.roleSelect = this.getFilter(roles);
        this.levelSelect = this.getFilter(levels);
    }

    /**
     * Re-renders all selectboxes with correct selection limits
     * Selection limit 0 means multiselect while 1 means only single item can be selected
     * @param except string type of selectbox to not rerender
     */
    reRenderMultiSelects (except = null) {
        switch (except) {
        case this.CLASSIFIER_ENUM.KEYS.DEPARTMENT:
            this.reRenderRoleSelect(1);
            this.reRenderLevelSelect(1);
            break;
        case this.CLASSIFIER_ENUM.KEYS.ROLE:
            this.reRenderDepartmentSelect(1);
            this.reRenderLevelSelect(1);
            break;
        case this.CLASSIFIER_ENUM.KEYS.LEVEL:
            this.reRenderDepartmentSelect(1);
            this.reRenderRoleSelect(1);
            break;
        default:
            this.reRenderDepartmentSelect(0);
            this.reRenderRoleSelect(0);
            this.reRenderLevelSelect(0);
        }
    }

    reRenderDepartmentSelect (selectionLimit) {
        if (this.departmentSelect.settings.selectionLimit === selectionLimit) {
            return;
        }
        this.departmentSelect.settings.selectionLimit = selectionLimit;
        this.toggleDepartment = !this.toggleDepartment;
    }

    reRenderRoleSelect (selectionLimit) {
        if (this.roleSelect.settings.selectionLimit === selectionLimit) {
            return;
        }
        this.roleSelect.settings.selectionLimit = selectionLimit;
        this.toggleRole = !this.toggleRole;
    }

    reRenderLevelSelect (selectionLimit) {
        if (this.levelSelect.settings.selectionLimit === selectionLimit) {
            return;
        }
        this.levelSelect.settings.selectionLimit = selectionLimit;
        this.toggleLevel = !this.toggleLevel;
    }


    /**
     * Return filter used to initialize one multiselect
     * @param values
     * @returns object
     */
    getFilter (values) {
        const settings = {
            checkBoxes: true,
            showCheckAll: false,
            showUncheckAll: false,
            enableSearch: true,
            smartButtonMaxItems: 2,
            selectionLimit: 0,
            idProperty: 'id'
        };

        const events = {
            onItemDeselect: this.getItemCallBack(),
            onItemSelect: this.getItemCallBack(),
            onSelectionChanged: this.getSelectionChangedCallback()
        };
        return { models: [values[0]], options: values, settings, events };
    }

    /**
     * Callback function to call when selectbox selection changes
     * Callback is called after change
     * @returns {Function}
     */
    getSelectionChangedCallback () {
        return () => {
            const { departmentSelect, roleSelect, levelSelect } = this;
            if (!departmentSelect.models.length) {
                departmentSelect.models = [this.allDepartmentModel];
            }
            if (!roleSelect.models.length) {
                roleSelect.models = [this.allRoleModel];
            }
            if (!levelSelect.models.length) {
                levelSelect.models = [this.allLevelModel];
            }

            if (departmentSelect.models.length <= 1
                && roleSelect.models.length <= 1
                && levelSelect.models.length <= 1
            ) {
                this.reRenderMultiSelects();
            }
        };
    }

    /**
     * Callback function that is called when item is added or removed from selectbox
     * Callback is called before selectionChanged callback
     * @returns {Function}
     */
    getItemCallBack () {
        return item => {
            const { departmentSelect, roleSelect, levelSelect, CLASSIFIER_ENUM } = this;
            const isAllModel = item.id === null;

            // if allModel model is chosen, set only it as selected model
            if (item.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT && isAllModel) {
                departmentSelect.models = [this.allDepartmentModel];
            }
            if (item.type === CLASSIFIER_ENUM.KEYS.ROLE && isAllModel) {
                roleSelect.models = [this.allRoleModel];
            }
            if (item.type === CLASSIFIER_ENUM.KEYS.LEVEL && isAllModel) {
                levelSelect.models = [this.allLevelModel];
            }

            switch (item.type) {
            case CLASSIFIER_ENUM.KEYS.DEPARTMENT:
                if (!isAllModel) {
                    departmentSelect.models = departmentSelect.models.filter(model => model.id !== null);
                }
                if (departmentSelect.models.length > 1) {
                    this.reRenderMultiSelects(CLASSIFIER_ENUM.KEYS.DEPARTMENT);
                }
                break;
            case CLASSIFIER_ENUM.KEYS.ROLE:
                if (!isAllModel) {
                    roleSelect.models = roleSelect.models.filter(model => model.id !== null);
                }
                if (roleSelect.models.length > 1) {
                    this.reRenderMultiSelects(CLASSIFIER_ENUM.KEYS.ROLE);
                }
                break;
            default:
                if (!isAllModel) {
                    levelSelect.models = levelSelect.models.filter(model => model.id !== null);
                }
                if (levelSelect.models.length > 1) {
                    this.reRenderMultiSelects(CLASSIFIER_ENUM.KEYS.LEVEL);
                }
            }
        };
    }

    beforeSave () {
        this.resetFormDrls();
        const { departmentSelect, roleSelect, levelSelect, lodash } = this;

        const departmentDrlId = lodash.get(departmentSelect.models, '0.id', null);
        const roleDrlId = lodash.get(roleSelect.models, '0.id', null);
        const levelDrlId = lodash.get(levelSelect.models, '0.id', null);

        if (departmentSelect.models.length > 1) {
            lodash.forEach(departmentSelect.models, department => {
                this.addDrl(department.id, roleDrlId, levelDrlId);
            });
        }
        else if (roleSelect.models.length > 1) {
            lodash.forEach(roleSelect.models, role => {
                this.addDrl(departmentDrlId, role.id, levelDrlId);
            });
        }
        else {
            lodash.forEach(levelSelect.models, level => {
                this.addDrl(departmentDrlId, roleDrlId, level.id);
            });
        }
    }

    addDrl (department, role, level) {
        this.form.model.courseTargets.push({
            id: null,
            departmentId: department,
            roleId: role,
            levelId: level,
            type: this.form.model.type
        });
    }

    save (event) {
        event.currentTarget.classList.add('loading');
        event.currentTarget.disabled = true;
        this.beforeSave();
        this.form.save()
            .then(() => this.uibModalInstance.close())
            .finally(() => {
                event.currentTarget.classList.remove('loading');
                event.currentTarget.disabled = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/drl/add/index.js